import { useEffect, useState } from "react"

import { Button } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { ContentContainer, MessageContainer, Title, Subtitle } from "./styled"
import IconBox from "../../components/IconBox"
import UIIcon from "../../components/UIIcon"
import { useLinkRequestById } from "../../api/hooks/useLinkRequestById"
import { sendCustomEvent } from "../../events/events"

const SuccessLinking = ({ requestId }: { requestId: string | undefined }) => {
  const navigate = useNavigate()
  const [shouldPoll, setShouldPoll] = useState(!!requestId)
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)

  const handleQuitEvent = () => {
    sendCustomEvent({
      eventName: "quit",
    })
  }

  const handleClickDone = () => {
    handleQuitEvent()
    navigate("/quit")
  }

  const requestIdStatus = shouldPoll ? requestId : undefined

  const { data, isLoading } = useLinkRequestById(requestIdStatus)

  useEffect(() => {
    if (data && data.paymentToolId) {
      setShouldPoll(false)
      setIsButtonDisabled(false)
    }
  }, [data])

  return (
    <ContentContainer>
      <MessageContainer>
        <IconBox size="lg" color="yellow">
          <UIIcon iconName="check" size={45} />
        </IconBox>
        <Title variant="h3">
          Запрос на привязку и пополнение счета отправлен
        </Title>
        <Subtitle variant="h5">
          Подтвердите безакцептное списание в приложении банка
        </Subtitle>
      </MessageContainer>
      <Button
        disabled={isLoading || isButtonDisabled}
        variant="contained"
        fullWidth
        onClick={handleClickDone}
      >
        Готово
      </Button>
    </ContentContainer>
  )
}

export default SuccessLinking
